import BottomFixedCallToAction from "@/features/Common/components/BottomFixedCallToAction";
import GetSupportPanel from "@/features/Common/components/GetSupportPanel";
import IconLoader from "@/features/Common/components/IconLoader";
import Panel from "@/features/Common/components/Panel";
import { defaultFullscreenPageStyling } from "@/theme";
import { convertPxToRem, replaceCentsFromAmount } from "@/utils";
import { Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function DocMedsConsultationCompleteWithoutMeds() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const price = "R249.00";

  function onGoHomeButtonClick() {
    navigate("/");
  }

  return (
    <Stack
      spacing={3}
      minHeight="100vh"
      position="relative"
      sx={{
        ...defaultFullscreenPageStyling,
        paddingBottom: convertPxToRem(130),
      }}
    >
      <Stack spacing={1} alignItems="center">
        <Typography variant="h2" component="h1">
          {t("DocMedsConsultationCompleteWithoutMeds.title")}
        </Typography>
      </Stack>

      <Panel sx={{ boxShadow: "none" }}>
        <Stack direction="row" gap={2}>
          <IconLoader
            icon="InformationSymbolFilledCircleIcon"
            color="primary"
            sx={{ fontSize: convertPxToRem(30) }}
          />
          <Stack>
            <Typography variant="body1" fontWeight={600}>
              {t("DocMedsConsultationCompleteWithoutMeds.info.title")}
            </Typography>
            <Typography variant="body2">
              {t("DocMedsConsultationCompleteWithoutMeds.info.subtitle")}
            </Typography>
          </Stack>
        </Stack>
      </Panel>

      <Panel>
        <Stack spacing={2}>
          <Typography variant="h3" component="h2" fontWeight={600}>
            {t("DocMedsConsultationCompleteWithoutMeds.whatHappensNow.title")}
          </Typography>
          <Typography variant="body1" fontSize={convertPxToRem(14)}>
            <Trans
              i18nKey="DocMedsConsultationCompleteWithoutMeds.whatHappensNow.subtitle"
              values={{ price: replaceCentsFromAmount(price) }}
            />
          </Typography>
        </Stack>
      </Panel>

      <GetSupportPanel />

      <BottomFixedCallToAction
        buttonText="common.goHomeButton"
        onButtonClick={onGoHomeButtonClick}
        ariaLabel="common.goHomeButton"
        analyticsPageName="Doc Meds Consultation Complete Without Meds"
      />
    </Stack>
  );
}
